// Configuración de Google AdSense
export const adSenseConfig = {
  // Client ID de AdSense (reemplaza con tu ID real)
  clientId: 'ca-pub-7501182635387640',
  
  // Configuración de anuncios por página
  adSlots: {
    // Landing page
    landingHero: {
      id: process.env.VUE_APP_ADSENSE_SLOT_HERO || '1983569385',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    landingContent: {
      id: process.env.VUE_APP_ADSENSE_SLOT_CONTENT || '1983569385',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    landingFeatured: {
      id: process.env.VUE_APP_ADSENSE_SLOT_FEATURED || '1983569385',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    landingAbout: {
      id: process.env.VUE_APP_ADSENSE_SLOT_ABOUT || '1983569385',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    
    // Blog
    blogHero: {
      id: process.env.VUE_APP_ADSENSE_SLOT_BLOG_HERO || '1234567894',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    blogInFeed: {
      id: process.env.VUE_APP_ADSENSE_SLOT_BLOG_IN_FEED || '1234567895',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    blogFooter: {
      id: process.env.VUE_APP_ADSENSE_SLOT_BLOG_FOOTER || '1234567896',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    blogSidebar: {
      id: process.env.VUE_APP_ADSENSE_SLOT_SIDEBAR || '1234567897',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    blogInArticle: {
      id: process.env.VUE_APP_ADSENSE_SLOT_IN_ARTICLE || '1234567898',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    
    // Post detail
    postSidebar: {
      id: process.env.VUE_APP_ADSENSE_SLOT_POST_SIDEBAR || '1234567899',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    postInArticle: {
      id: process.env.VUE_APP_ADSENSE_SLOT_POST_IN_ARTICLE || '1234567900',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    postHeader: {
      id: process.env.VUE_APP_ADSENSE_SLOT_POST_HEADER || '1234567901',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    },
    postFooter: {
      id: process.env.VUE_APP_ADSENSE_SLOT_POST_FOOTER || '1234567902',
      format: 'auto',
      style: 'display:block',
      lazyLoad: true
    }
  },
  
  // Configuración de comportamiento
  settings: {
    // Habilitar/deshabilitar anuncios
    enabled: false, //process.env.VUE_APP_ADSENSE_ENABLED !== 'false',
    
    // Modo de desarrollo (muestra placeholders en lugar de anuncios reales)
    developmentMode: process.env.NODE_ENV === 'development',
    
    // Tiempo de espera para cargar anuncios (ms)
    loadTimeout: 5000,
    
    // Número máximo de anuncios por página
    maxAdsPerPage: 4,
    
    // Distancia mínima entre anuncios (px)
    minAdSpacing: 200
  }
}

// Función para obtener configuración de un slot específico
export function getAdSlotConfig(slotName) {
  return adSenseConfig.adSlots[slotName] || null
}

// Función para verificar si AdSense está habilitado
export function isAdSenseEnabled() {
  return adSenseConfig.settings.enabled
}

// Función para verificar si estamos en modo desarrollo
export function isDevelopmentMode() {
  return adSenseConfig.settings.developmentMode
} 